import React, { useEffect, useState } from 'react';
import { View, Text } from 'react-native-web';
import * as Animatable from 'react-native-animatable';
import PropTypes from 'prop-types';
import Lottie from 'react-lottie';

// Utils
import { isProfilePendingApproval } from '../utils/util_truck_helpers';

// Configs
import GLOBAL from '../configs/config_global';
import { Button } from './component_button';
import * as RootNavigation from '../navigation/RootNavigation';
import RouteKeys from '../navigation/RouteKeys';

export function TierBlockView(props) {
    const {
        lottieFile,
        sectionBenefit,
        topTextMargin,
        lottieSize,
        style,
        availableTier
    } = props;

    const [showLottie, setShowLottie] = useState(false);

    useEffect(() => {
        setTimeout(() => setShowLottie(true), 500);
    }, []);

    return(
        isProfilePendingApproval() ?
            <Animatable.View
                anmation={'fadeIn'}
                style={[{ flex: 1, width: '100%', backgroundColor: 'white', alignItems: 'center', justifyContent: 'center', paddingHorizontal: 56 }].concat(style)}>
                <Text style={{ textAlign: 'center', fontSize: 18, color: GLOBAL.COLOR.BASIC.NEUTRAL_DARK_GREY }}>
                    This feature will become available once your profile is approved
                </Text>
            </Animatable.View>
            :
            <Animatable.View
                anmation={'fadeIn'}
                style={[{ flex: 1, width: '100%', backgroundColor: 'white', alignItems: 'center', justifyContent: 'center', paddingHorizontal: 56 }].concat(style)}>
                <View style={{ width: lottieSize, height: lottieSize, alignItems: 'center', justifyContent: 'center' }}>
                    {
                        showLottie &&
                        <Animatable.View animation={'zoomIn'}>
                            <Lottie
                                options={{
                                    loop: true,
                                    autoplay: true,
                                    animationData: lottieFile,
                                    rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
                                }}
                                width={lottieSize}
                                height={lottieSize}
                                isStopped={false}
                                isPaused={false}
                            />
                        </Animatable.View>
                    }
                </View>

                <Animatable.Text
                    animation={'fadeIn'} delay={1500}
                    style={{ textAlign: 'center', fontSize: 18, marginTop: topTextMargin, color: GLOBAL.COLOR.BASIC.NEUTRAL_DARK_GREY }}>
                    {sectionBenefit}
                </Animatable.Text>

                <Animatable.Text
                    animation={'fadeIn'} delay={2000}
                    style={{ textAlign: 'center', fontWeight: 'bold', fontSize: 18, marginTop: 32, color: GLOBAL.COLOR.BASIC.NEUTRAL_DARK_GREY }}>
                    Available for Tier {availableTier?.toString()}{availableTier < 3 ? '+' : ''} Vendors
                </Animatable.Text>

                <Animatable.View
                    animation={'fadeIn'} delay={2500}
                    style={{ alignItems: 'center', width: '100%' }}>
                    <Text style={{ fontSize: 16, color: GLOBAL.COLOR.BASIC.NEUTRAL_LIGHT_GREY, marginTop: 16, alignSelf: 'center' }}>
                        You are currently on Tier {GLOBAL.DATA.USER['tier']}
                    </Text>
                </Animatable.View>

                {/* Upgrade Button */}
                <Animatable.View animation={'fadeIn'} delay={3000} style={{ alignItems: 'center', width: '100%', marginTop: 32 }}>
                    <Button
                        text={'See Upgrade Options'}
                        style={{ width: 250, alignSelf: 'center' }}
                        onPress={() => {
                            RootNavigation.jumpTo(RouteKeys.ACCOUNT_SETTINGS_STACK);
                            setTimeout(() => RootNavigation.navigate(RouteKeys.SUBSCRIPTION_TIERS), 500);
                        }}
                    />
                </Animatable.View>
            </Animatable.View>
    )
}

// region Props
TierBlockView.propTypes = {
    lottieFile: PropTypes.any,
    lottieSize: PropTypes.number,
    sectionBenefit: PropTypes.string,
    topTextMargin: PropTypes.number,
    style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    availableTier: PropTypes.number
};

TierBlockView.defaultProps = {
    lottieFile: null,
    lottieSize: 240,
    sectionBenefit: 'Section benefits here',
    topTextMargin: 24,
    style: {},
    availableTier: 1
};
// endregion
